module.exports = __webpack_public_path__ + "static/img/img_2.504c6996.jpg";